<template>
    <v-card>
        <v-card-title>
            <v-flex xs12 sm6>
                <div class="headline">Bancas</div>            
            </v-flex>
            <v-flex xs12 sm5>
                <v-text-field
                        append-icon="search"
                        label="Pesquisar"
                        single-line
                        hide-details
                        v-model="search"></v-text-field>
            </v-flex>                        
        </v-card-title>
        <v-card-title>            
            <exam-filters v-model="filters" :options="['semester', 'course']" :can-select-any-course="true" :semester-required="true"></exam-filters>
        </v-card-title>           
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :no-data-text="noData"
            :no-results-text="noResult"
            :rows-per-page-text="rowsPerPageT"
            class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr :class="getExamRowClass(props.item)" v-if="!isSmallScreen && props.item.situation != 'Cancelada'">
                    <td>{{ props.item.id }}</td>
                    <td>
                        <ul class="no-padding">
                            <ol class="no-padding studentName" v-for="(studentName, id) in props.item.studentName" :key="id">
                                {{ studentName }}
                            </ol>
                        </ul>
                    </td>
                    <!-- <td>{{ props.item.title }}</td> -->
                    <td>{{ props.item.date | moment('DD/MM/YYYY') }}</td>
                    <td>{{ props.item.hour }}</td>
                    <td>{{ props.item.place }}</td>
                    <td>
                        <v-chip small :class="['grey darken-2', 'white--text']" v-if="getExamStatus(props.item) == 'Finalizada'">
                            Avaliação {{ getExamStatus(props.item) }}
                        </v-chip>
                        <v-chip small :class="['info', 'white--text']" v-else-if="getExamStatus(props.item) == 'Pendente'">
                            Avaliação {{ getExamStatus(props.item) }}
                        </v-chip>
                        <v-chip small :class="['warning', 'white--text']" v-else>
                            Avaliação {{ getExamStatus(props.item) }}
                        </v-chip>
                    </td>
                    <td>
                        <v-btn color="cyan darken-1" floating small dark fab title="Avaliar trabalho" 
                            v-if="getExamStatus(props.item) != 'Finalizada'"
                            :to="{ name: 'examEvaluate', params: { id: props.item.id } }">
                            <v-icon dark>gavel</v-icon>
                        </v-btn>
                        <v-btn color="info" floating small dark fab title="Ver ficha de avaliação" 
                            v-if="getExamStatus(props.item) == 'Finalizada'"
                            :to="{ name: 'examDetail', params: { id: props.item.id } }">
                            <v-icon dark>description</v-icon>
                        </v-btn>                    
                    </td>
                </tr>
                <tr :class="getExamRowClass(props.item)" v-if="isSmallScreen">
                    <td>
                        <v-icon>person</v-icon>
                        <strong>
                            <ul class="no-padding">
                                <ol class="no-padding studentName" v-for="(studentName, id) in props.item.studentName" :key="id">
                                    {{ studentName }}
                                </ol>
                            </ul>
                        </strong><br>
                        <v-icon>date_range</v-icon> {{ props.item.date | moment('DD/MM/YYYY') }} às {{ props.item.hour }} <br>
                        <v-icon>edit_location</v-icon> {{ props.item.place }} <br>

                        <v-chip small :class="['grey darken-2', 'white--text']" v-if="getExamStatus(props.item) == 'Finalizada'">
                            {{ getExamStatus(props.item) }}
                        </v-chip>
                        <v-chip small :class="['info', 'white--text']" v-else-if="getExamStatus(props.item) == 'Pendente'">
                            {{ getExamStatus(props.item) }}
                        </v-chip>
                        <v-chip small :class="['warning', 'white--text']" v-else>
                            {{ getExamStatus(props.item) }}
                        </v-chip>
                    </td>
                    <td>
                        <v-btn color="cyan darken-1" floating small dark title="Avaliar trabalho" 
                            v-if="getExamStatus(props.item) != 'Finalizada'"
                            :to="{ name: 'examEvaluate', params: { id: props.item.id } }">
                            <v-icon dark>gavel</v-icon> Avaliar
                        </v-btn>
                        <v-btn color="info" floating small dark title="Ver ficha de avaliação" 
                            v-if="getExamStatus(props.item) == 'Finalizada'"
                            :to="{ name: 'examEvaluate', params: { id: props.item.id } }">
                            <v-icon dark>description</v-icon> Ver ficha
                        </v-btn>                    
                    </td>                    
                </tr>                
            </template>       
        </v-data-table>
        <v-card-text>
            <p class="pa-1 mb-0">Acima estão listadas as bancas que você participa como examinador.</p>
            <p class="green lighten-4 pa-1 mb-0">Bancas realizadas hoje são exibidas com destaque <strong class="green--text">verde</strong>.</p>
            <p class="brown--text pa-1 mb-0">Bancas em que você participa como examinador suplente são exibidas com destaque <strong>marrom</strong>.</p>
        </v-card-text>
        <fullscreen-spinner></fullscreen-spinner>
    </v-card>
</template>

<script>
    import { noData, noResult, rowsPerPageT } from './../locale/vuetify';
    import auth from './../auth'
    import ExamFilters from './ExamFilters.vue'

    export default {
        name: 'ExamEvaluateList',
        components: {
            ExamFilters
        },
        data() {
            return {
                desktopHeaders: [
                    { text: 'Id', align: 'left', value: 'id' },
                    { text: 'Aluno', align: 'left', value: 'studentName' },
                    /*{ text: 'Título', align: 'left', value: 'title' },*/
                    { text: 'Data', align: 'left', value: 'date' },
                    { text: 'Hora', align: 'left', value: 'hour' },
                    { text: 'Local', align: 'left', value: 'place' },
                    { text: 'Situação', align: 'left', value: 'status' },
                    //{ text: 'Examinadores', align: 'left', value: 'examinersName' },                    
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                mobileHeaders: [
                    { text: 'Banca', align: 'left', value: 'short'},
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                items: [],
                totalItems: -1,
                search: '',
                pagination: {
                    rowsPerPage: 10,
                    sortBy: 'date',
                    descending: false
                },
                loading: false,
                noData: noData,
                noResult: noResult,
                rowsPerPageT: rowsPerPageT,
                filters: {},
                classColor: ''
            }
        },
        computed: {
            isSmallScreen() {
                return ['xs','sm'].includes(this.$vuetify.breakpoint.name)
            },
            headers() {
                return this.isSmallScreen ? this.mobileHeaders : this.desktopHeaders
            }            
        },
        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
                },
                deep: true
            },
            filters: {
                handler() { 
                    this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
                },
                deep: true                
            }              
        },
        methods: {
            mountSearchString() {
                let searchString = [];
            
                for (let key in this.filters) {
                    let value = this.filters[key]
                    if (!!value && key != 'view') {
                        searchString[key] = value
                    }
                }
                searchString['search'] = this.search;
            
                let str = "";
                for (let key in searchString) {
                    if (str != "") {
                        str += "&";
                    }
                    str += key + "=" + encodeURIComponent(searchString[key]);
                }

                return str
            },            
            getDataFromApi() {
                this.loading = true
                return new Promise((resolve, reject) => {
                    const { sortBy, descending, page, rowsPerPage } = this.pagination
                    let offset = 0;
                    if (rowsPerPage > 0) offset = (page - 1) * rowsPerPage

                    const params = {
                        search: this.mountSearchString(),
                        view: 'evaluator',
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        limit: rowsPerPage,
                        offset: offset
                    }

                    // exams | searchExamEvaluateList
                    this.$http.post('searchExamEvaluateList', params).then(response => {
                        this.loading = false
                        const items = response.body
                        const total = parseInt(response.headers.get('X-Pagination-Total-Count'))
                        resolve( { items, total })
                    }, response => {
                        console.error('Erro ao carregar as bancas do servidor.')
                        console.log(response)
                    })
                })
            },
            getExamStatus(exam) {
                let status = exam.situation;
                let examDate = this.getExamDate(exam);
                let now = new Date();

                if (status == 'Finalizada') {
                    this.classColor = 'grey darken-2'
                }
                else if (status == 'Pendente') {
                    this.classColor = 'info'
                }
                
                if(examDate.toISOString().substr(0, 10) < now.toISOString().substr(0, 10) && status != 'Finalizada') {
                    this.classColor = 'warning'
                    status = 'Atrasada'
                }

                return status
            },
            getExamStatusOld(exam) {
                let status = 'Avaliação pendente',
                   evaluation = this.getExamEvaluation(exam)

                if (evaluation != null) {
                    if (typeof evaluation.start !== 'undefined' && evaluation.start != null) {
                        status = 'Avaliação iniciada' // em ' + evaluation.start
                        if (evaluation.finish != null) {
                            status = 'Avaliação finalizada' // em ' + evaluation.finish
                        }
                    }
                }
                if (status == 'Avaliação pendente') {
                    let examDate = this.getExamDate(exam),
                        now = new Date()
                    if (examDate.toISOString().substr(0, 10) < now.toISOString().substr(0, 10)) {
                        status = 'Avaliação atrasada'
                    }
                }
                return status
            },
            getExamStatusClass(exam) {
                let status = this.getExamStatus(exam)
                if (status == 'Avaliação atrasada') return 'warning';
                if (status == 'Avaliação iniciada') return 'info';
                if (status == 'Avaliação finalizada') return 'success';
                return 'grey darken-2'
            },
            getExamDate(exam) {
                return new Date(exam.date + 'T' + exam.hour + ':00')
            },
            getExamRowClass(exam) {
                let examDate = this.getExamDate(exam),
                    examFinishDate = (examDate.getTime() + (30 * 60 * 1000)),
                    now = new Date(),
                    classes = []
                if (examDate <= now && examFinishDate >= now) {
                    classes.push('green lighten-2')
                } else if (examDate.getDate() == now.getDate() && examDate.getMonth() == now.getMonth() && examDate.getFullYear() == now.getFullYear()) {
                    classes.push('green lighten-4')
                }
                if (this.isSubstitute(exam)) {
                    classes.push('brown--text')
                }
                return classes
            },
            getExamEvaluation(exam) {
                if (typeof exam.evaluations !== 'undefined' && typeof exam.evaluations[auth.user.id] !== 'undefined') {
                    return exam.evaluations[auth.user.id]
                }
                return null
            },
            isSubstitute(exam) {
                if (typeof exam.examiners !== 'undefined' && exam.examiners.length > 0) {
                    if (exam.examiners.includes(auth.user.id))      return false
                }
                if (typeof exam.substitutes !== 'undefined' && exam.substitutes.length > 0) {
                    if (exam.substitutes.includes(auth.user.id))    return true
                }
                return false
            }            
        },
        mounted() {
            this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ExamEvaluateList.vue?45370475